import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const FadingVeilWrapper = styled.div.withConfig({
  displayName: "FadingVeil__FadingVeilWrapper"
})(["&.white-veil-leave{opacity:0;}height:100%;width:100%;position:absolute;z-index:11;background:white;transition:opacity 0.25s ease-in;opacity:1;"]);
const FadingVeil = () => {
  return /*#__PURE__*/_jsx(FadingVeilWrapper, {
    "data-test-id": "ep-fading-veil"
  });
};
export default FadingVeil;